export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_06.7d2b14cd.jpg";